(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[844],{

/***/ "t0Ho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StarHollow", function() { return StarHollow; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var StarHollow = function StarHollow(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5515 16.95C20.1005 17.391 19.8595 18.137 19.9665 18.762L20.9145 24.314L15.9505 21.692C15.3925 21.397 14.6135 21.397 14.0545 21.692L9.0905 24.314L10.0385 18.762C10.1455 18.137 9.9045 17.392 9.4525 16.95L5.4375 13.019L10.9865 12.208C11.6105 12.117 12.2415 11.657 12.5215 11.089L15.0025 6.03802L17.4845 11.089C17.7635 11.657 18.3955 12.118 19.0175 12.208L24.5685 13.019L20.5515 16.95ZM27.4417 12.078C27.2937 11.619 26.8887 11.299 26.3587 11.222L19.3027 10.192L16.1487 3.77C15.9117 3.288 15.4827 3 14.9997 3C14.5187 3 14.0897 3.288 13.8537 3.77L10.6977 10.192L3.64266 11.222C3.11266 11.299 2.70766 11.621 2.55766 12.082C2.40966 12.54 2.55066 13.038 2.93366 13.413L8.03866 18.413L6.83366 25.471C6.74266 26 6.92166 26.486 7.31266 26.771C7.70366 27.057 8.21866 27.074 8.69066 26.825L15.0007 23.493L21.3117 26.825C21.7857 27.076 22.3027 27.053 22.6917 26.77C23.0807 26.486 23.2577 26 23.1677 25.471L21.9627 18.413L27.0687 13.413C27.4507 13.038 27.5907 12.539 27.4417 12.078V12.078Z"
  }));
};

/***/ })

}]);